export const parseJson = (json: string) => {
    try {
        return JSON.parse(json);
    } catch (e) {
        console.warn('Cannot parse JSON', e);
        return null;
    }
};
